import styled from 'styled-components';

export const TaxesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  align-items: end;
`;

export const IpiCell = styled.div<{ dividerHeight?: number }>`
  position: relative;
  padding-left: 12px;

  @media (min-width: 1200px) {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 65%;
      transform: translateY(-50%);
      width: 1px;
      height: ${({ dividerHeight = 48 }) => `${dividerHeight}px`};
      background: #dfe1e6;
      pointer-events: none;
    }
  }
`;
